import { render, staticRenderFns } from "./SuperuserSidebar.vue?vue&type=template&id=3ae1ba5b&"
import script from "./SuperuserSidebar.vue?vue&type=script&lang=js&"
export * from "./SuperuserSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports